module.exports = __webpack_public_path__ + "static/img/03.5e15aeec.jpg";